import { laravelAxios } from 'src/config/axios/laravelAxios';

export class OverdueCustomerModalService {
  static async getOverdueCustomers(customer_id: number) {
    const response = await laravelAxios.get(
      `/admin/customers/non_payment/${customer_id}`
    );
    return response.data;
  }
}
